import { render, staticRenderFns } from "./OpenIDCallback.vue?vue&type=template&id=9d70ad08&"
import script from "./OpenIDCallback.vue?vue&type=script&lang=js&"
export * from "./OpenIDCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports